// 选择取件人
<template>
  <div class="selectConsignee">
    <!-- 流程 -->
    <userSaveFlow :index="3"></userSaveFlow>
    <!-- 正文内容 -->
    <div class="select-who">
      <div
        class="who"
        @click="goSaveFinish()">我自己</div>
      <div
        class="who other"
        @click="changeSelectWrapper">他人</div>
    </div>
    <!-- 搜索框 -->
    <div
      class="search-wrapper"
      v-show="selecteWapperStatus">
      <div class="search-box">
        <div class="top">
          <p class="title">选择取件人</p>
        </div>
        <div class="input-box clearfix">
          <el-input
            placeholder="请输入手机号或姓名搜索"
            v-model="key_word"
            clearable>
          </el-input>
          <el-button
            class="btn-search"
            type="primary"
            @click="getUserList()"
            round>搜索</el-button>
          <el-button
            class="btn-search btn-cancel"
            type="primary"
            @click="cancel()"
            round>取消</el-button>
        </div>
        <div class="user-box" v-if="departmentList.length !== 0">
          <div class="scroll-left">
            <!-- 一级部门 -->
            <div 
              class="group"
              :class="[active === departmentList[0].id ? 'active' : '']"
              @click="getGroupUserList(departmentList[0].id)">{{departmentList[0].name}}</div>
            <!-- 二级部门 -->
            <div
              class="group second one-line-overhidden"
              :class="[active === item.id ? 'active' : '']"
              v-for="item in departmentList[0].children"
              :key="item.id" @click="getGroupUserList(item.id)">{{item.name}}</div>
            <keep-alive>
              <multiSelector
                class="group department-list"
                :value.sync="selectedDepartmentId"
                :data="departmentList"
                :props="props"
                placeholder="请选择下级部门"
                @confirm="handleConfirm"
                v-if="!isSearch"></multiSelector>
            </keep-alive>
          </div>
            
          
          <!-- 联系人列表 -->
          <!-- <keep-alive> -->
          <div class="member-scroll" v-if="userData.list.length !== 0">
            <div
              class="member-list"
              :class="{'search-list': isSearch}"
              v-loading="userData.loading">
              <div
                class="member"
                :class="{'myself': memberItem.user_id === $store.state.delivererUserId}"
                v-for="(memberItem, memberIndex) in userData.list"
                :key="memberIndex"
                @click="selectMember(memberIndex, memberItem)">

                <!-- {{memberItem.user_id === $store.state.delivererUserId}}
                {{memberItem.user_id}}
                {{$store.state.delivererUserId}} -->
                  <span class="name"
                    v-text="memberItem.user_name"></span>
                  <span class="phoneNo"
                    v-text="memberItem.phone_no"></span>
                  <span class="selectSpan"
                    :class="{ selected: memberItem.selected }"></span>
                </div>
              </div>
            </div>
            <!-- </keep-alive> -->
          <!-- 联系人不存在 -->
          <div
            class="content-null"
            v-else>
            <img src="../../../../static/turnoverCabinet/images/icon/search_list.png" alt="">
            <p
              class="text">{{isSearch ? '联系人不存在' : '当前部门没有联系人'}}</p>
          </div>
        </div>
        <!-- 确定联系人按钮 -->
        <div class="btn-area">
          <span
          class="btn-confirm"
            @click="goSaveFinish('other')">确定</span>
        </div>
      </div>
      <span
        class="close"
        @click="changeSelectWrapper"></span>
    </div>

    
    <!-- 上一步 -->
    <span class="turnoverCabinet-btn-back" v-show="$store.state.isShowRBot" @click="back">上一步</span>
  </div>
</template>

<script>
import userSaveFlow from '../userSave/userSaveFlow'
import multiSelector from '../module/multi-selector.vue'
import { cabinetApi } from "../../../../static/turnoverCabinet/js/api.js"
import { showToast } from '../../../../static/turnoverCabinet/js/utility'

export default {
  name: 'selectConsignee',
  components: {
    userSaveFlow,
    multiSelector
  },
  data () {
    return {
      // 侧边栏选中
      active: '0',

      // 搜索
      key_word: '',
      isSearch: false,
      selecteWapperStatus: false,
      // 部门数据
      departmentList: [],
      selectedDepartmentId: '',
      props: {
        value: 'id',
        parent_value: 'parent_id',
        lable: 'name',
        children: 'children'
      },
      // 用户数据
      userData: {
        list: [],
        loading: false,
        selected: {}
      }
    }
  },
  created () {
    console.log('deliverData', this.$store.state.deliverData)
    this.getDepartmentList()
    this.getUserList('0')
  },
  mounted () {
  },
  methods: {
    // 一级二级部门获取部门用户列表
    getGroupUserList(id) {
      this.active = id
      this.getUserList( id )
    },
    // 显示或隐藏选择取件框
    changeSelectWrapper () {
      this.selecteWapperStatus = !(this.selecteWapperStatus)
    },
    // 获取部门列表
    async getDepartmentList  () {
      let vm = this

      let res = await cabinetApi.getDepartmentList()
      if (res.meta.code === 200) {
        this.departmentList = res.data
      } else {
        showToast(res.meta.message)
      }
    },
    // 确认部门
    handleConfirm (e) {
      // console.log('已触发', e)
      // console.log('部门id', e.value)
      if (e.detail.length === 0) {
        showToast('请选择部门')
        return
      } else {
        this.active = 'select'
        this.selectedDepartmentId = e.value
        this.getUserList(e.value)
      }
    },
    // 获取用户列表
    async getUserList (department_id) {
      let vm = this
      // 清空上次选择用户信息
      vm.userData.selected = {}
      let data = {
        key_word: vm.key_word,
        department_id: department_id ? department_id : ''
      }

      vm.userData.loading = true
      let res = await cabinetApi.getUserList(data)
      vm.userData.loading = false
      if (res.meta.code === 200) {
        let userList = [...res.data.list]
        for (let i in userList) {
          userList[i].selected = false
        }
        vm.userData.list = [...userList]

        vm.isSearch = vm.key_word === '' ? false : true
        console.log('当前用户列表', vm.userData.list)
      } else {
        showToast (res.meta.message)
      }
    },
    // 选中用户
    selectMember (memberIndex, memberItem) {
      console.log('memberItem', memberItem)
      // 当为投递者，不能选择
      if (memberItem.user_id === this.$store.state.delivererUserId) {
        return
      }
      for (let i in this.userData.list) {
        this.$set(this.userData.list[i], 'selected', false)
      }
      this.$set(this.userData.list[memberIndex], 'selected', true)
      this.userData.selected = memberItem
    },
    // 跳转到存件完成页面
    goSaveFinish (other) {
      if (other) {
        if (!this.userData.selected.user_id) {
          showToast('请选择取件人')
          return
        } 
      }

      // 确认被投递的用户
      this.$store.state.deliverData.user_id = other ? this.userData.selected.user_id : this.$store.state.delivererUserId
      this.$router.push({
        // 你要跳转的地址
        path: '/turnoverCabinet/saveFinish'
      })
    },
    // 返回上一页  （选择箱格）
    back () {
      this.$router.push('/turnoverCabinet/selectCell')
    }
  },
  watch: {
    // 监听关键字变化
    key_word (newVal) {
      if (newVal === '') {
        this.getUserList(this.selectedDepartmentId)
        this.isSearch = false
      }
    }
  }
}
</script>

<style lang="less">
.selectConsignee{
  width: 100%;
  height: 100%;
  .one-line-overhidden {
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
  }
  .department-list .end-selected-view {
    font-size: 0.26rem;
  }

  .department-list .yt-selected-view {
    width: 50%;
    height: 50%;
    top: 0;
    margin: auto;
  }

  .select-who{
    width: 4.56rem;
    margin: 0 auto;
    padding-top: 1.5rem;
  }

  .select-who .who{
    width: 100%;
    height: 1.82rem;
    line-height: 1.82rem;
    margin-bottom: 0.6rem;
    text-align: center;
    border-radius: 0.1rem;
    font-size: 0.7rem;
    font-weight: bold;
    background: -webkit-linear-gradient(to top ,#076abf, #4cacff); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(to top,#076abf, #4cacff); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(to top,#076abf, #4cacff); /* Firefox 3.6 - 15 */
    background: linear-gradient(to top,#076abf, #4cacff);
    box-shadow: #2c4b64 0px 0px 0.2rem;
  }

  .select-who .who.other{
    background: -webkit-linear-gradient(to top ,#076abf, #4cabfe); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(to top,#076abf, #4cabfe); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(to top,#076abf, #4cabfe); /* Firefox 3.6 - 15 */
    background: linear-gradient(to top,#076abf, #4cabfe);
  }

  .search-wrapper{
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 0;
    left: 0;
  }

  .search-wrapper .search-box{
    width: 7.6rem;
    height: 8.8rem;
    margin: 1rem auto 0;
    text-align: center;
    border-radius: 0.1rem;
    box-sizing: border-box;
    background-color: #ffffff;
  }

  .search-wrapper .search-box .top{
    position: relative;
  }

  .search-wrapper .search-box .top .title{
    font-size: 0.34rem;
    line-height: 0.88rem;
    font-weight: bold;
    color: #ffffff;
    background-color: #0d508f;
  }

  .search-wrapper .search-box .input-box{
    padding: 0.2rem;
    background-color: #f1f1f1;
    /* border-bottom: 1px solid #cccccc; */
  }

  .search-wrapper .search-box .input-box .el-input{
    width: 5.6rem;
    height: 0.58rem;
    float: left;
  }

  .search-wrapper .search-box .input-box .btn-search{
    width: 1.43rem;
    border-radius: 3px;
    float: right;
    padding: 0;
  }

  input.el-input__inner,
  .search-wrapper .search-box .input-box .btn-search{
    height: 0.58rem !important;
    line-height: 0.58rem !important;
    font-size: 0.24rem;
  }

  .user-box {
    width: 100%;
    display: flex;
  }

  .user-box .scroll-left {
    background-color: #f6f6f8;
    height: 6.05rem;
    text-align: left;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .user-box .group {
    width: 2.9rem;
    color: #333333;
    font-size: 0.26rem;
    line-height: 0.9rem;
    text-indent: 1em;
    position: relative;
    }
  .user-box .group::after {
    display: block;
    content: '';
    width: auto;
    height: 0.02rem;
    background-color: #ececee;
    position: absolute;
    bottom: 0;
    left: 1em;
    right: 1em;
    }
  .user-box .group.second {
    padding-left: 0.5em;
    }
  .user-box .group.active {
    color: #2d83f3;
    background-color: #fff;
    border-left: 0.08rem solid #2d83f3;
    }

  .user-box .department-list,
  .user-box .content-null{
    width: 2.9rem;
    height: 6.05rem;
    position: relative;
  }

  .user-box .department-list{
    background-color: #f1f1f1;
    overflow: visible;
  }

  .user-box .member-scroll {
    width: 4rem;
    margin: 0 0.4rem;
    overflow: hidden;
  }

  .user-box .member-list{
    overflow-y: scroll;
    overflow-x: hidden;
    height: 6.05rem;
    position: relative;
  }

  .user-box .member-list::after {
    content: '';
    width: 20px;
    height: 100%;
    background-color: #ffffff;
    position: absolute;
    right: -20px;
    top: 0;
    z-index: 9999;
  }

  .user-box .member-list.search-list{
    width: 100%;
    height: 6.05rem;
  }

  .user-box .member-list .member{
    display: block;
    width: 100%;
    height: 0.88rem;
    font-size: 0.24rem;
    color: #0d508f;
  }

  .user-box .member-list .member.myself {
    color: #cccccc;
  }

  .user-box .member-list .el-scrollbar__wrap {
    width: 100%;
    overflow: hidden;
  }

  .user-box .member-list .member{
    padding: 0.12rem 0 0.02rem;
    border-bottom: 1px solid #f9f9f9;
    position: relative;
  }

  .user-box .member-list .member span{
    display: block;
    text-align: left;
    line-height: 0.35rem;
  }

  .user-box .member-list .member span.phoneNo{
    font-size: 0.20rem;
  }

  .user-box .member-list .member span.selectSpan {
    width: 0.34rem;
    height: 0.34rem;
    border-radius: 50%;
    padding: 0.01rem;
    border: 1px solid #cccccc;
    position: absolute;
    bottom: 0;
    top: 0;
    right: 0;
    margin: auto 0;
  }

  .user-box .member-list .member span.selectSpan.selected{
    border:none;
    padding: 0;
    background: url(../../../../static/turnoverCabinet/images/selected.png) center no-repeat;
    background-size: 0.34rem 0.34rem;
  }

  .search-wrapper .close{
    display: block;
    width: 50px;
    height: 50px;
    background-size: 50px;
    background: url(../../../../static/turnoverCabinet/images/icon/close.png) center no-repeat;
    position: absolute;
    top: 10px;
    right: 10px;
  }


  .content-null{
    width: 100%;
    margin:  0 auto;
    padding-top: 1rem;
  }

  .content-null img{
    width: 1rem;
    height: 1rem;
    margin: 0.4rem;
  }

  .content-null .text{
    font-size: 0.3rem;
    color: #bfbfbf;
  }

  .btn-area{
    width: 100%;
    height: 0.88rem;
    border-top: 1px solid #f0f0f0;
  }

  .search-wrapper .btn-confirm{
    display: block;
    width: 1.45rem;
    margin: 0.15rem auto 0;
    height: 0.58rem;
    font-size: 0.22rem;
    line-height: 0.58rem;
    color: #ffffff;
    border-radius: 5px;
    background-color: #49aafe;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/turnoverCabinet/userSave/selectConsignee.vue